var map = {
	"./font/fons_1.otf": "u5Zg",
	"./font/fons_2.otf": "Y/2f",
	"./font/fons_3.ttf": "bO7M",
	"./font/pan.ttf": "ZKr+",
	"./font/siyuanH.otf": "dbAB",
	"./font/siyuanS.otf": "h4iB",
	"./greytabbt.png": "qRem",
	"./logo.png": "7Otq",
	"./tabbt2022.png": "7zZK",
	"./tabbt2023_1.png": "FLlA",
	"./tabbt2023_2.png": "C5tH",
	"./tabbt2024_1.png": "rRFd",
	"./tabbt2024_2.png": "TRgn",
	"./xi.jpg": "wqZX",
	"./xi_1.png": "BFh2",
	"./xi_11.png": "Gxto",
	"./xi_12.png": "0leq",
	"./xi_13.png": "MLBA",
	"./xi_2.png": "Aquc",
	"./xi_3.png": "VPbQ",
	"./xi_4.png": "UmkL",
	"./xi_5.png": "Sd3I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1